import React from "react";
import Text from "@/components/ui/text";
import MandatoryIndication from "@/components/controls/Questions/MandatoryIndication";
import { HelpTextTooltip } from "@/components/shared/HelpTextTooltip";

interface Props {
  label: string;
  isMandatory?: boolean;
  tooltipText?: string | null;
  indicator?: React.ReactNode;
  children: React.ReactNode;
}

const QuestionContainer: React.FC<Props> = ({
  label,
  isMandatory,
  tooltipText,
  indicator,
  children
}) => (
  <div>
    <div className="mb-2">
      <div className="flex items-center gap-2">
        <Text variant="bodySecondary">{label}</Text>
        {isMandatory && <MandatoryIndication />}
        <HelpTextTooltip tooltipText={tooltipText} />
        {indicator}
      </div>
    </div>
    {children}
  </div>
);

export default QuestionContainer;
